'use client';
var INPUT_STATES = {
    default: {},
    success: {
        color: "primary"
    },
    error: {
        color: "disruption"
    }
};
var defaultProps = {
    labelElement: "label",
    size: "md1",
    inputContainer: function(children) {
        return children;
    },
    elementsOrder: [
        "label",
        "input",
        "hint"
    ],
    state: "default",
    states: INPUT_STATES
};

export { INPUT_STATES, defaultProps };
